import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import HighlightValue from '../HighlightValue';

const UnrealizedProfitLossCellValue = memo(({ instrumentId, positionId, isToFormat }) => {
  const fixedValue = useSelector(
    (state) => state.currencies.positionsUnrealizedProfitLoss?.[instrumentId]?.[positionId]?.unrealizedProfitLoss,
  );

  return <HighlightValue value={Math.floor(fixedValue)} isToFormat={isToFormat} />;
});

UnrealizedProfitLossCellValue.propTypes = {
  instrumentId: PropTypes.string,
  positionId: PropTypes.string,
  isToFormat: PropTypes.bool,
};

UnrealizedProfitLossCellValue.defaultProps = {
  instrumentId: '',
  positionId: '',
  isToFormat: false,
};

export default memo(UnrealizedProfitLossCellValue);
